import {View, Text, Image} from 'react-native';
import React from 'react';
import {styles} from './styles';
import {Images} from '../../../../constants/Images';
import CheckBoxAttach from './CheckBoxAttach/CheckBoxAttach';

const MinimumAlert = ({minimumOrder}) => {
  return (
    <View style={styles.container}>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          width: '100%',
          gap: 10,
        }}>
        <Image
          source={Images.warningB}
          style={{
            width: 15,
            height: 15,
          }}
        />
        <Text
          style={{
            fontSize: 12,
            lineHeight: 16,
            fontFamily: 'TCCC-UnityText Bold',
            color: 'black',
          }}>
          Pedido mínimo
        </Text>
      </View>

      <Text
        style={{
          marginLeft: -3,
          marginTop: 10,
          fontSize: 12,
          lineHeight: 16,
          fontFamily: 'TCCC-UnityHeadline Regular',
          color: 'black',
        }}>
        É necessário atingir o pedido mínimo de R${' '}
        <Text
          style={{
            fontFamily: 'TCCC-UnityText Bold',
          }}>
          {minimumOrder
            ? minimumOrder.toFixed(2).toString().replace('.', ',')
            : '300,00'}{' '}
        </Text>
        reais. As taxas não contam para o valor mínimo.
      </Text>
    </View>
  );
};

export default MinimumAlert;
